export const zPreprocessIntString = (val: unknown) => {
  if (typeof val === 'string') {
    if (val === '') return undefined
    const v = parseInt(val, 10)
    // '1.あ' -> 1 になってしまい後続のバリデーションが効かなくなるので
    // 文字列に戻した時に変化がある場合は元の文字列を返す
    if (String(v) !== val) return val
    return v
  }
  return val
}

export const zPreprocessBooleanString = (val: unknown) => {
  if (typeof val === 'string' && val !== '') return true
  return false
}
